import React, { FunctionComponent, ReactElement } from 'react';
import { Provider } from 'react-redux';
import { FocusStyleManager } from '@blueprintjs/core';
import { BrowserRouter } from 'react-router-dom';
import { LicenseManager, ModuleRegistry, AllModules } from '@ag-grid-enterprise/all-modules';
import AlertNotification from 'containers/AlertNotification';
import SessionExpirationNotification from 'containers/SessionExpirationNotification';
import LockoutNotification from 'containers/LockoutNotification';
import store from './data/store';
import Http from './shared/http';
import RootRoutes from './root-routes';
import Navbar from './shared/navbar';
import ScrollTop from './shared/scroll-top';

import './vendor/flexboxgrid.css';
import './app.scss';
import '../node_modules/normalize.css/normalize.css';
import '../node_modules/@blueprintjs/core/lib/css/blueprint.css';
import '../node_modules/@blueprintjs/icons/lib/css/blueprint-icons.css';
import '../node_modules/@blueprintjs/datetime/lib/css/blueprint-datetime.css';

import '@blueprintjs/popover2/lib/css/blueprint-popover2.css';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-grid.css';
import '@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css';

LicenseManager.setLicenseKey(
  'CompanyName=Ss8 Networks, Inc.,LicensedGroup=Dev1 Dev2 Dev3,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=6,LicensedProductionInstancesCount=0,AssetReference=AG-029177,SupportServicesEnd=17_July_2023_[v2]_MTY4OTU0ODQwMDAwMA==3f6fd2484b16a0babcd2fd5c7854b42c',
);

ModuleRegistry.registerModules(AllModules);

FocusStyleManager.onlyShowFocusOnTabs();

const App: FunctionComponent = (): ReactElement => {
  Http.init(store);
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ScrollTop>
          <React.Fragment>
            <Navbar />
            <AlertNotification />
            <SessionExpirationNotification />
            <LockoutNotification />
            <RootRoutes />
          </React.Fragment>
        </ScrollTop>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
